<template>
    <div class="videoBox">
      <div class="videoleft">
        <div class="boxback">
          <div class="labelviedeo">视频</div>
          <div v-for="(item,index) in list" :key="item.videoUrl" class="leftlist">
         <!-- <img @click="clickvideo(index)" style="width:100%;height:100%;border-radius: 10px;object-fit: contain;" :src="imagesList[0].completes[0].url" alt=""> -->
         <div class="absoluteleft">左乳</div>
         <!-- <div class="absoluteright">右乳</div> -->
         <video @click="clickvideo(index,1)" style="width:100%;height:100%;border-radius: 10px;object-fit: contain;" :src="item.videoUrl" alt=""></video>
        </div>
          <div v-for="(item,index) in listrights" :key="item.videoUrl" class="leftlist">
         <!-- <img @click="clickvideo(index)" style="width:100%;height:100%;border-radius: 10px;object-fit: contain;" :src="imagesList[0].completes[0].url" alt=""> -->
         <div class="absoluteright">右乳</div>
         <!-- <div class="absoluteright">右乳</div> -->
         <video @click="clickvideo(index,2)" style="width:100%;height:100%;border-radius: 10px;object-fit: contain;" :src="item.videoUrl" alt=""></video>
        </div>
        </div>
      </div>
      <div class="videocenter">
     <div style="height:100vh;">
         <video
      id="myVideo"
      class="video-js"
    >
      <source
        :src="videoUrl"
        type="video/mp4"
      >
    </video>
     </div>
     <!-- <div class="carouselBox">
		<el-carousel :loop="false" :autoplay="false" class="carousel">
			<el-carousel-item class="el-car-item" v-for="(list, index) in dataList" :key="index">
				<div v-for="(imgList,index1) in list" :key="index1" class="divSrc">
					<img class="img" :src="imgList.imagePath" />
				</div>
			</el-carousel-item>
		</el-carousel>
	</div> -->
      </div>
      <div class="videoright">
        <div class="rightbox">
          <div class="screenshot">
          截图
        </div>
         <!-- <el-row :gutter="20" type="flex" justify="center">
      <el-col :span="20">
        <div id="father" class="grid-content bg-purple">
          <div id="swiper-box" class="swiper-box" :style="{transform:'translateX('+currentOffset+'px)'}">
           <swiper-item  :width="width" v-for="i in 10"></swiper-item>
          </div>
          <i class="el-icon-arrow-left" @click="left"></i>
          <i class="el-icon-arrow-right" @click="right"></i>
        </div>
      </el-col>
      
    </el-row> -->
    	<div class="boxright" v-for="(list, index) in imagesList" :key="index">
				<!-- <div v-for="(imgList,index1) in list" :key="index1" class="divSrc"> -->
          <!-- <div>{{list}}</div> -->
					<div v-for="(item,index) in list.completes" :key="index">
            <img @click='clickTime(item.frame)' class="img" :src="item.url" />
          </div>
				<!-- </div> -->
			</div>
    	<div class="boxright" v-for="(list, index) in manulImagesList" :key="index">
				<!-- <div v-for="(imgList,index1) in list" :key="index1" class="divSrc"> -->
					<img @click='clickTime(list.frame)' class="img" :src="list.url" />
				<!-- </div> -->
			</div>
        </div>
        <div class="screenshotBox">
          <div class="clickscreenshot" @click='scrollLock'>
        截图
      </div>
        </div>
      </div>
    </div>  
</template>

<script>
import { slider, slideritem } from 'vue-concise-slider'
export default {
  
  //   components: { SocialSign },
  //   components: { SocialSign },
  //   components: { SocialSign },111
  components: {
      slider,
      slideritem
    },
  data() {
    return {
      activeindex:'',
      activetype:'',
      listrights:[],
      fps:'',
      imagesList:'',
      manulImagesList:'',
      fpss:'',
      videoIds:'',
      lists:'',
      list:[],
      dataList: [
        
      ],
      serialNos:'',
      myPlayer:'',
      ids:'',
      videoUrl:'',//视频地址
    };
  },
  created(){
    this.ids = this.$route.query.id;
  },
  mounted() {
    // this.byEvents();
    this.getList();
    setTimeout(() => {
      this.initVideo();  //初始化视频播放器
    }, 300)
    const video = document.getElementById('myVideo');
    video.setAttribute('crossorigin', 'Anonymous')
    },
  methods: {
    scrollLock() {
    var currentTime = document.getElementById("myVideo").firstChild.currentTime;
    console.log('currentTime',currentTime);
    var formEdit = {
      studyId:Number(this.ids),
      // videoId:this.list[this.activeleft].videoId,
      videoId:this.videoIds,
      // this.list[this.activeleft].fps
      frame:parseInt(this.fpss*currentTime),
    }
     this.http.post(this.GLOBAL.BASE_URL + 'v1/study/ultrasound/snapshot?token=' + sessionStorage.getItem("token"), formEdit)
					.then(response => {
						console.log(response)
            if(response.data.code == 200){
              this.$message({
                  message: "截图成功",
                  type: "success",
                });
                // this.getList();
                // setTimeout(() => {
                  this.getactiveList();
                  // this.clickvideo(this.activeindex,this.activetype);
                // }, 500);
                return;
            }
             this.$message({
          message: response.data.msg,
          type: "error",
        });
        // this.$refs["upload"].$refs["upload-inner"].handleChangeedit()
					})
					.catch(err => {
						console.error(err);
					});
    



		// const url = window.URL.createObjectURL(blob);
		// const a = document.createElement('a');  
		// a.style.display = 'none';
		// a.href = url;
		// a.download = fileName;
		// document.body.appendChild(a);
		// a.click();
		// setTimeout(function () {
		// 	document.body.removeChild(a);
		// 	window.URL.revokeObjectURL(url);
		// }, 1000);
  },
    clickTime(frame){
      console.log(this.fps)
    var second = frame/this.fps;
    console.log('second',second)
       setTimeout(() => {     
      this.myPlayer.currentTime(second);
      this.myPlayer.pause();
    }, 100)


    //       for (let index = 0; index < this.list.length; index++) {
    //           console.log(this.list[index]);
    //         if(this.list[index].serialNo == seriesUid) {
    //           console.log(index);
    //           this.clickvideo(index)
    //             setTimeout(() => {
            
    // }, 100)
    //          }
    //       }

      // console.log(value)
      // seriesUid
      //确定到固定帧
      // if(value == 'https://ylz-wlhy.oss-cn-qingdao.aliyuncs.com/upload/20211120/WechatIMG11525.png'){
      //   this.myPlayer.currentTime(2.25);
      // }else {
      //   this.myPlayer.currentTime(1.42);
      // }
    },
    // getStudyInfo(){
    //    depot
    //       .get({
    //         url: "/v1/study/film/listUsByStudyId",
    //         params: {
    //           token: sessionStorage.getItem("token"),
    //           id: this.ids,
    //         },
    //       })
    //       .then((res) => {
    //         console.log(res);
    //         // this.lists = res.data.;
    //         //  this.lists.forEach((element) => {
    //         //    if(element.seriesUid == this.serialNos) {
    //         //   console.log(element.list)
    //         //  this.dataList = element.list
    //         //  this.byEvents();
    //         //  }
    //         //  })
    //         this.dataList = res.data;
    //         console.log(this.dataList)
    //         // this.byEvents();
    //       })
    //       .catch((err) => {
    //         console.log(err);
    //       });
    // },
    // byEvents() {
		// 		let newDataList = [];
		// 		let current = 0
		// 		if (this.dataList && this.dataList.length > 0) {
		// 			for (let i = 0; i <= this.dataList.length - 1; i++) {
		// 				if (i % 3 !== 0 || i === 0) {	//数据处理成几张展示
		// 					if (!newDataList[current]) {
		// 						newDataList.push([this.dataList[i]])
		// 					} else {
		// 						newDataList[current].push(this.dataList[i])
		// 					}
		// 				} else {
		// 					current++
		// 					newDataList.push([this.dataList[i]])
		// 				}
		// 			}
		// 		}
		// 		this.dataList = [...newDataList]

		// 	},
    getactiveList() {
       this.$http.get(this.GLOBAL.BASE_URL + 'v1/study/ultrasound/' + this.ids + '?token=' + sessionStorage.getItem("token"))
     .then(response => {
      if(this.activetype == 1){
        this.manulImagesList = response.data.data.lefts[this.activeindex].manulImages;
      }else{
        this.manulImagesList = response.data.data.listrights[this.activeindex].manulImages; 
      }
      // this.imagesList = response.data.data[0].images;
      
      // console.log('this.imagesList',this.imagesList);
      // console.log('this.manulImagesList',this.manulImagesList);
      // this.serialNos = response.data.data[0].serialNo;
      //触发视频左边第一个
     })
     .catch(err => {
      console.error(err);
     });
    },
    getList() {
       this.$http.get(this.GLOBAL.BASE_URL + 'v1/study/ultrasound/' + this.ids + '?token=' + sessionStorage.getItem("token"))
     .then(response => {
      this.list = response.data.data.lefts;
      this.listrights = response.data.data.rights;
      console.error('this.list',this.list);
      this.fps = response.data.data.lefts[0].fps
      // this.list = response.data.data
      this.videoUrl = response.data.data.lefts[0].videoUrl;
      console.error('this.videoUrl',this.videoUrl);
      // this.imagesList = response.data.data[0].images;
      this.manulImagesList = response.data.data.lefts[0].manulImages;
      // console.log('this.imagesList',this.imagesList);
      // console.log('this.manulImagesList',this.manulImagesList);
      // this.serialNos = response.data.data[0].serialNo;
      //触发视频左边第一个
      setTimeout(() => {
        this.clickvideo(0,1);
      }, 1000);
     })
     .catch(err => {
      console.error(err);
     });
    },
    clickvideo(index,type){
      console.log(index);
      console.log(type);
      this.activeindex = index;
      this.activetype = type;
      console.log('this.activeindex',this.activeindex);
      console.log(this.myPlayer);
     if(this.activetype == 1){
      this.videoIds = this.list[this.activeindex].videoId;
      this.fpss = this.list[this.activeindex].fps;
      let src = this.list[this.activeindex].videoUrl
      this.myPlayer.src({src:src,type:"video/mp4"});
    this.myPlayer.load();
    this.myPlayer.play();
    this.imagesList = this.list[this.activeindex].images;
    this.manulImagesList = this.list[this.activeindex].manulImages;
     }else {
      this.videoIds = this.listrights[this.activeindex].videoId;
      this.fpss = this.listrights[this.activeindex].fps;
      let src = this.listrights[this.activeindex].videoUrl
      this.myPlayer.src({src:src,type:"video/mp4"});
    this.myPlayer.load();
    this.myPlayer.play();
    this.imagesList = this.listrights[this.activeindex].images;
    this.images = this,
    this.manulImagesList = this.listrights[this.activeindex].manulImages;
     }
    //  this.lists.forEach((element) => {
    //          console.log(element);
    //          if(element.seriesUid == this.serialNo) {
    //           console.log(element.list)
    //          this.dataList = element.list
    //          console.error('this.dataList',this.dataList)
    //          this.byEvents();
    //          }
    //         });
    // console.log('this.serialNo',this.serialNo);
    },
    initVideo() {
        //初始化视频方法
        this.myPlayer = this.$video(myVideo, {
          //是否显示控制栏
          controls: true,
          //是否自动播放,muted:静音播放
          autoplay: true,
          //是否静音播放
          muted:false,
          //是否流体自适应容器宽高
          fluid:true,
          //设置视频播放器的显示宽度（以像素为单位）
          width: "800px",
          //设置视频播放器的显示高度（以像素为单位）
          height: "400px",
          playbackRates: [0.5,0.8,1,2,4],// # 倍速播放配置
        });
      }
  },
};
</script>

<style lang="scss">
.videoBox {
  display: flex;
  background: black;
  height: 100vh;
}
.videoleft {
  padding: 10px;
  box-sizing: border-box;
  overflow-y: scroll;
  width: 255px;
  // background: pink;
}
.videocenter {
  width: calc(100% - 510px);
  // background: skyblue;
  // border-right: 1px solid #fff;
}
.videoright {
  position: relative;
  width: 255px;
  height: 100vh;
  overflow-y: scroll;
  padding:10px;
  box-sizing: border-box;
  // background: #fff;
}
.video_text{
    width: 70%;
    margin: 0 auto;
  }
  video:focus{
    outline: 0; //去掉选中蓝框
  }
  .video-js {
    height: 100%!important;
    padding-top: 0px!important;
  }
  .video-js .vjs-big-play-button{
    /*对播放按钮的样式进行设置*/
    width: 100px;
    height: 50px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate3d(-50%,-50%,0);
  }
  .leftlist {
    position: relative;
    width: 100%;
    // height: 80px;
    // border: 1px solid #fff;
    // border-radius: 10px;
    padding: 20px;
    padding-bottom: 0px;
    box-sizing: border-box;
  }
  .absoluteleft {
    position: absolute;
    bottom: 15px;
    left: 30px;
    width: 66px;
    height: 30px;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    background: linear-gradient(90deg, #894D5B 0%, rgba(137,77,91,0.1) 100%);
    border-radius: 4px;
  }
  .absoluteright {
    position: absolute;
    bottom: 15px;
    right: 30px;
    width: 66px;
    height: 30px;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    background: linear-gradient(90deg, #894D5B 0%, rgba(137,77,91,0.1) 100%);
    border-radius: 4px;
  }
  .absoluteright {
    position: absolute;
    color: #fff;
    display: flex;
    font-size: 14px;
    align-items: center;
    justify-content: center;
    bottom: 15px;
    right: 30px;
    width: 66px;
    height: 30px;
    background: linear-gradient(270deg, #894D5B 0%, rgba(137,77,91,0.1) 100%);
    border-radius: 4px;
  }
  .leftlist video {
    height: 104px!important;
border-radius: 12px;
border: 1px solid #FFFFFF;
  }
  .carouselBox {
		margin: 0 auto;
		width: 100%;
		height: 0;
		// background-color: #2276F5;
		.carousel{
			width: 100%;
			height: 100%;
			.el-car-item {
				width: 100%;
				height: 100%;
				display: flex;
				.divSrc{
					width: 33.34%;
					height: 100%;
					background: #fff;
					margin-right: 0px;
					.img {
						width: 100%;
						height: 100%;
            object-fit: cover;
					}
				}
				
			}
			/deep/.el-carousel__arrow{
				background: red !important;
				display: block !important;
				margin-top: 65px;
			}
			
			
		}
		.el-car-item {
			width: 100%;
			display: flex;

			.img {
				width: 284px;
				height: 184px;
				margin-right: 20px;
				cursor: pointer;
			}
		}
	}
  .el-carousel__container {
    height: 100%!important;
  }
  .boxright {
    width: 100%;
    padding: 20px;
    box-sizing: border-box;
    // margin-bottom: 20px;
      .img {
        border: 1px solid #fff;
        border-radius: 10px;
        width: 100%;
        height: 100%;
        object-fit: contain;
    }
  }
  .labelviedeo {
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    height: 40px;
    background: linear-gradient(180deg, #444444 0%, #222222 100%);
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
    font-size: 14px;
  }
  .boxback {
    background: #1D1D1D;
  }
  .boxback .leftlist:first-child {
    padding-top: 20px;
  }
  .screenshot {
    width: 100%;
    height: 40px;
    background: linear-gradient(180deg, #444444 0%, #222222 100%);
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .rightbox {
    background: #1D1D1D;
    // height: 100%;
    padding-bottom:25px;
    box-sizing: border-box;
    // padding: 20px;
    // box-sizing: border-box;
  }
  .clickscreenshot {
    position: fixed;
    bottom: 10px;
    color: #B33552;
    width: 215px;
    height: 40px;
    border-radius: 4px;
    border: 1px solid #B33552;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .screenshotBox {
    width: 228px;
    height: 50px;
    background: #1D1D1D;
    position: fixed;
    right: 0px;
    bottom: 0px;
    margin-right: 15px;
  }
</style>



// WEBPACK FOOTER //
// src/views/usvideo/viewer.vue